import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppContext } from "../libs/contextLib";
import { userStates } from '../libs/userLib';
import { isAbsoluteURL } from '../libs/urllib';
import config from "../config";

function queryString(name, url = window.location.href) {
  name = name.replace(/[[]]/g, "\\$&");

  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
  const results = regex.exec(url);

  if (!results) {
    return null;
  }
  if (!results[2]) {
    return "";
  }

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export default function UnauthenticatedRoute({ children, ...rest }) {
  const { pathname } = useLocation();

   /**
   * Return a redirect either to the requested or confirm page.
   */
  const getRedirect = () => {
    if (userState === userStates.UNCONFIRMED) {
      if(pathname !== '/confirm') {
        return (
          <Navigate to={
            `/confirm`
          } />
        );
      }
      else {
        return children;
      }
    }
    else if (userState === userStates.CONFIRMED) {
      return (
        <Navigate to={redirect === '' || redirect === null ? '/' : redirect} />
      );
    }
    else if (
      userState === userStates.FORCE_CHANGE_PASSWORD
    ) {
      return (
        <Navigate to={
          `/user/password`
        } />
      );
    }
    else {
      const loginLink = config.links.loginUserType;
      if(isAbsoluteURL(loginLink)) {
        window.location = loginLink;
      }
      else {
        return (
          <Navigate to={
            loginLink
          } />
        );
      }
    }
  };

  const { userState } = useAppContext();
  const redirect      = queryString('redirect');
  return (
    // Only render children if unauthenticated.
    // If the path is just `/login` and that is not in config as loginUserType
    // we'll need to redirect a user to an external url to choose their login
    // type.
    userState !== userStates.UNAUTHENTICATED || (
      config.links.loginUserType !== '/login' &&
      pathname === '/login'
    ) ? (
      getRedirect()
    ) : (
      children
    )
  );
}
